export default {
  FIND_AVAILABILITY_TO_HIRE_PRODUCT_QUERY: Symbol.for('FIND_AVAILABILITY_TO_HIRE_PRODUCT_QUERY'),
  INVESTMENT_PRODUCT_REPOSITORY: Symbol.for('INVESTMENT_PRODUCT_REPOSITORY'),
  AVAILABILITY_TO_HIRE_PRODUCT_STATE_MANAGER: Symbol.for('AVAILABILITY_TO_HIRE_PRODUCT_STATE_MANAGER'),
};
